(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const WRITE_PARAM = 'cr_write';
    const TRUSTOO_WRITE = '.tt-write-reviews';
    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    /* Resolve when an element matching selector appears inside scope (or null after timeout). */
    const waitFor = (selector, scope, timeout = 10000) =>
      new Promise((resolve) => {
        const found = scope.querySelector(selector);
        if (found) return resolve(found);
        let timer;
        const obs = new MutationObserver(() => {
          const el = scope.querySelector(selector);
          if (el) {
            obs.disconnect();
            clearTimeout(timer);
            resolve(el);
          }
        });
        obs.observe(scope, { childList: true, subtree: true });
        timer = setTimeout(() => {
          obs.disconnect();
          resolve(null);
        }, timeout);
      });

    /* Product URL that asks the product page to open Trustoo's review form. */
    const writeUrl = (url) => {
      const u = new URL(url, window.location.origin);
      u.searchParams.set(WRITE_PARAM, '1');
      return u.pathname + u.search;
    };

    /* Trustoo shows its review form inside #trustoo-mask. */
    const isFormOpen = () => {
      const mask = document.getElementById('trustoo-mask');
      return !!mask && window.getComputedStyle(mask).display !== 'none';
    };

    /* Click Trustoo's own "Write a review" button, which opens Trustoo's native form popup.
       Trustoo can add the button before its click handler is ready, so retry briefly. */
    const openTrustooForm = async (scope) => {
      const btn = await waitFor(TRUSTOO_WRITE, scope || document);
      if (!btn) return false;
      for (let i = 0; i < 12; i += 1) {
        btn.click();
        await sleep(600);
        if (isFormOpen()) return true;
      }
      return isFormOpen();
    };

    /* On a product page reached with ?cr_write=1, open Trustoo's form for that product. */
    const handleWriteParam = () => {
      if (window.__crWriteHandled) return;
      const params = new URLSearchParams(window.location.search);
      if (params.get(WRITE_PARAM) !== '1') return;
      window.__crWriteHandled = true;
      params.delete(WRITE_PARAM);
      const query = params.toString();
      history.replaceState(history.state, '', window.location.pathname + (query ? `?${query}` : '') + window.location.hash);
      openTrustooForm(document);
    };

    const VERIFIED_ICON =
      '<svg width="8" height="8" viewBox="0 0 10 10" aria-hidden="true"><path d="M2.2 5.2 4.1 7 7.8 3.2" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    class CustomerReviews {
      constructor(root) {
        this.root = root;
        this.source = root.dataset.source;
        this.onProduct = root.dataset.onProduct === 'true';
        this.productUrl = root.dataset.productUrl || '';
        this.writeBtn = root.querySelector('[data-cr-write]');
        this.cards = root.querySelector('[data-cr-cards]');
        this.carousel = root.querySelector('[data-cr-carousel]');
        this.modal = root.querySelector('[data-cr-modal]');

        this.onWrite = this.onWrite.bind(this);
        if (this.writeBtn) this.writeBtn.addEventListener('click', this.onWrite);
        if (this.modal) this.setupModal();
        this.setupCards();
      }

      destroy() {
        if (this.writeBtn) this.writeBtn.removeEventListener('click', this.onWrite);
        if (this.cardsObs) this.cardsObs.disconnect();
        if (this.modal) {
          this.closeModal();
          document.removeEventListener('keydown', this.onKey);
          this.modal.remove();
        }
      }

      async onWrite(e) {
        e.preventDefault();

        /* Product page, All products mode: review the product being viewed, no picker. */
        if (this.source === 'all' && this.onProduct) {
          this.writeBtn.setAttribute('aria-busy', 'true');
          await openTrustooForm(document);
          this.writeBtn.removeAttribute('aria-busy');
          return;
        }

        if (this.source === 'single') {
          if (this.cards) {
            /* Already on the selected product's page: open Trustoo's form here. */
            this.writeBtn.setAttribute('aria-busy', 'true');
            const opened = await openTrustooForm(this.cards);
            this.writeBtn.removeAttribute('aria-busy');
            if (opened || !this.productUrl) return;
          }
          if (this.productUrl) window.location.href = writeUrl(this.productUrl);
          return;
        }

        this.openModal();
      }

      /* ---------- Card enhancements (wording + carousel avatar/flag), reapplied whenever Trustoo renders ---------- */
      setupCards() {
        if (!this.cards) return;
        const label = this.root.dataset.verifiedLabel;
        const apply = () => {
          if (label) {
            this.cards.querySelectorAll('.verified-text, .tt-review-verify').forEach((el) => {
              if (el.textContent !== label) el.textContent = label;
            });
          }
          if (this.carousel) this.enhanceCarousel();
        };
        apply();
        this.cardsObs = new MutationObserver(apply);
        this.cardsObs.observe(this.cards, { childList: true, subtree: true });
      }

      enhanceCarousel() {
        this.carousel.querySelectorAll('.tt-card:not([data-cr-done])').forEach((card) => {
          card.setAttribute('data-cr-done', '');
          const nameEl = card.querySelector('.tt-review-name');
          if (!nameEl) return;
          const initials = nameEl.textContent
            .trim()
            .split(/\s+/)
            .slice(0, 2)
            .map((w) => w.charAt(0).toUpperCase())
            .join('');
          const avatar = document.createElement('div');
          avatar.className = 'cr-avatar';
          avatar.setAttribute('aria-hidden', 'true');
          avatar.textContent = initials;
          if (card.querySelector('.tt-review-verify')) {
            const badge = document.createElement('span');
            badge.className = 'cr-avatar__badge';
            badge.innerHTML = VERIFIED_ICON;
            avatar.appendChild(badge);
          }
          card.insertBefore(avatar, card.firstChild);

          const country = card.querySelector('.tt-review-country');
          const code = country ? country.textContent.trim() : '';
          if (/^[A-Za-z]{2}$/.test(code)) {
            const flag = document.createElement('img');
            flag.className = 'cr-flag';
            flag.src = `https://flagcdn.com/w40/${code.toLowerCase()}.png`;
            flag.width = 16;
            flag.height = 11;
            flag.alt = code.toUpperCase();
            flag.loading = 'lazy';
            nameEl.appendChild(flag);
          }
        });
      }

      /* ---------- Product picker ---------- */
      setupModal() {
        document.body.appendChild(this.modal);
        this.list = this.modal.querySelector('[data-cr-list]');
        this.search = this.modal.querySelector('[data-cr-search]');
        this.status = this.modal.querySelector('[data-cr-status]');
        this.panel = this.modal.querySelector('[role="dialog"]');
        this.hasMore = this.root.dataset.more === 'true';
        this.searchToken = 0;
        try {
          this.products = JSON.parse(this.root.querySelector('[data-cr-products]').textContent) || [];
        } catch (err) {
          this.products = [];
        }

        this.modal.addEventListener('click', (e) => {
          if (e.target.closest('[data-cr-close]')) {
            this.closeModal();
            return;
          }
          const item = e.target.closest('[data-cr-url]');
          if (item) window.location.href = writeUrl(item.dataset.crUrl);
        });
        this.search.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => this.runSearch(), 200);
        });
        this.onKey = (e) => {
          if (this.modal.hidden) return;
          if (e.key === 'Escape') this.closeModal();
          if (e.key === 'Tab') this.trapFocus(e);
        };
        document.addEventListener('keydown', this.onKey);
      }

      openModal() {
        if (!this.modal) return;
        this.lastFocus = document.activeElement;
        this.search.value = '';
        this.renderList(this.products);
        this.modal.hidden = false;
        document.documentElement.classList.add('cr-modal-open');
        requestAnimationFrame(() => this.search.focus());
      }

      closeModal() {
        if (!this.modal || this.modal.hidden) return;
        this.modal.hidden = true;
        document.documentElement.classList.remove('cr-modal-open');
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }

      trapFocus(e) {
        const items = Array.from(this.panel.querySelectorAll('button, input')).filter((el) => el.offsetParent !== null);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      async runSearch() {
        const q = this.search.value.trim().toLowerCase();
        const local = q ? this.products.filter((p) => p.t.toLowerCase().includes(q)) : this.products;
        if (!q || !this.hasMore) {
          this.renderList(local);
          return;
        }
        /* Large catalogues: search the whole store with Shopify predictive search. */
        const token = ++this.searchToken;
        this.setStatus(this.modal.dataset.loading);
        this.list.innerHTML = '';
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(
            `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`
          );
          const data = await res.json();
          if (token !== this.searchToken) return;
          const found = ((data.resources && data.resources.results && data.resources.results.products) || []).map((p) => ({
            t: p.title,
            u: p.url,
            i: (p.featured_image && p.featured_image.url) || p.image || '',
          }));
          this.renderList(found);
        } catch (err) {
          if (token === this.searchToken) this.renderList(local);
        }
      }

      setStatus(text) {
        this.status.textContent = text || '';
        this.status.hidden = !text;
      }

      renderList(items) {
        this.list.innerHTML = '';
        if (!items.length) {
          this.setStatus(this.modal.dataset.empty);
          return;
        }
        this.setStatus('');
        const frag = document.createDocumentFragment();
        items.forEach((p) => {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cr-modal__item';
          btn.dataset.crUrl = p.u;
          if (p.i) {
            const img = document.createElement('img');
            img.className = 'cr-modal__thumb';
            img.src = p.i;
            img.alt = '';
            img.width = 48;
            img.height = 48;
            img.loading = 'lazy';
            btn.appendChild(img);
          } else {
            const ph = document.createElement('span');
            ph.className = 'cr-modal__thumb';
            btn.appendChild(ph);
          }
          const title = document.createElement('span');
          title.textContent = p.t;
          btn.appendChild(title);
          li.appendChild(btn);
          frag.appendChild(li);
        });
        this.list.appendChild(frag);
      }
    }

    const init = (scope = document) => {
      scope.querySelectorAll('[data-cr]').forEach((el) => {
        if (el._cr) el._cr.destroy();
        el._cr = new CustomerReviews(el);
      });
    };

    const start = () => {
      init();
      handleWriteParam();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    /* Theme editor support */
    document.addEventListener('shopify:section:load', (e) => {
      init(e.target);
      /* Trustoo renders its cards only on page load, not when the editor re-renders this section. */
      const box = e.target.querySelector('[data-cr-cards] .custom-vstar-review-widget, [data-cr-cards] #trustoo-card-carousel-widget');
      if (!box) return;
      setTimeout(() => {
        if (box.isConnected && !box.children.length) {
          const note = document.createElement('p');
          note.className = 'cr__notice';
          note.textContent = 'Trustoo review cards show again when the preview reloads (save, then refresh).';
          box.parentNode.insertBefore(note, box);
        }
      }, 2500);
    });
    document.addEventListener('shopify:section:unload', (e) => {
      e.target.querySelectorAll('[data-cr]').forEach((el) => el._cr && el._cr.destroy());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
